import type {
  ApiKeysResponse,
  CreateApiKeyResponse,
} from "@server/types/responseTypes";
import { apiDelete, apiGet, apiPost, createOrgApiUrl } from "@/utils/apiUtils";

export const fetchApiKeys = async (orgId: string | null) => {
  if (!orgId) return [];
  const res = await apiGet<ApiKeysResponse>(createOrgApiUrl(orgId, "api-keys"));
  return res.data;
};

export const createApiKey = async ({
  organizationId,
  name,
}: {
  organizationId: string;
  name: string;
}) => {
  const res = await apiPost<CreateApiKeyResponse>(
    createOrgApiUrl(organizationId, "api-keys"),
    { name },
  );
  return res.data;
};

export const deleteApiKey = async ({
  organizationId,
  keyId,
}: {
  organizationId: string;
  keyId: string;
}) => {
  await apiDelete(createOrgApiUrl(organizationId, `api-keys/${keyId}`));
};
